// extracted by mini-css-extract-plugin
export default {"root":"LoanAuditDialog_root__h9av0","loanData":"LoanAuditDialog_loanData__2LFz2","entries":"LoanAuditDialog_entries__ylrxw"};